import { HttpClient } from '@angular/common/http';
import { Observable, catchError, throwError } from 'rxjs';
import { Inject, Injectable } from '@angular/core';
import { ParametrosResponseModel } from '../_models/parametrosResponse.model';
import { ParametrosInicialesResponse } from '../_models/parametros-inicialesResponse.model';
import { environment } from '../../../../environments/environment';
import { SmallParametrosModel } from '../_models/small-parametros-response.model';

@Injectable()
export class ParametersService {
  private readonly parameters: string = 'GetParametros';
  private readonly parametersNew: string = 'GetParametrosNew';
  private readonly initialParameters: string = 'ConParametrosIniciales';
  url!: string;

  constructor(
    private http: HttpClient,
    @Inject('BASE_URL') private baseUrl: string
  ) {
    this.url = baseUrl + 'api/main/';
  }

  private get urlParameters() {
    return this.url + this.parameters;
  }

  private get urlParametersNew() {
    return this.url + this.parametersNew;
  }

  private get urlInitialParameters() {
    return this.url + this.initialParameters;
  }

  GetParameters(): Observable<ParametrosResponseModel> {
    const endpointUrl = `${this.urlParameters}`;
    return this.http.get<ParametrosResponseModel>(endpointUrl);
  }

  GetParametersNew(): Observable<SmallParametrosModel[]> {
    const endpointUrl = `${this.urlParametersNew}`;
    return this.http.get<SmallParametrosModel[]>(endpointUrl);
  }

  GetInitialParameters(body: any): Observable<ParametrosInicialesResponse> {
    const endpointUrl = `${this.urlInitialParameters}`;
    console.log('body', body);
    return this.http.post<ParametrosInicialesResponse>(endpointUrl, body).pipe(
      catchError((error) => {
        console.error('Error en la solicitud:', error);
        return throwError(() => error);
      })
    );
  }
}
